import { useContext } from 'react';
import { ThemeContext } from 'contexts/theme';

export default function useTheme() {
  const value = useContext(ThemeContext);
  return value;
}
